import { Pipe, PipeTransform } from '@angular/core';
import { SanitizeChar } from 'app/shared/util/sanitize-char';

@Pipe({
  name: 'filterReference'
})
export class FilterReferencePipe implements PipeTransform {

  constructor(
    private sanitizeChar: SanitizeChar) { }

  transform(value: any[], args: string = ""): any {
    if (args && args.length && value)
      return value.filter(item => this.sanitizeChar.convert(item.name.toLocaleLowerCase()).indexOf(this.sanitizeChar.convert(args.toLocaleLowerCase())) > -1);
    else
      return value;
  }

}
